var Marionette = require('backbone.marionette');

var EntitiesSelectView = require('../entities/entities-select');
var DocumentTypesCollection = require('../../collections/document-types-collection');
var RemoteSuggesterView = require('../common/remote-suggester-input.js');
var AssignReviewersForm = require('./assign-reviewers-form');
var DocumentMetaModal = require('./document-meta-modal');

var Radio = require('backbone.radio');
var sessionChannel = Radio.channel('session');

var CommonUtils = require('../../utils/common-utils.js');
var Dicts = require('../../data/dicts');

var DocumentUploadView = Marionette.View.extend({
    template: require('../../templates/documents/upload.html'),

    regions: {
        organizations: "#organizations-list",
        patients: '#patients-list',
        docTypes: '#doc-types-list',
        assignReviewersFormRegion: '#assign-reviewers-form',
        addMetaFormRegion: '#add-meta-form'
    },

    childViewEvents: {
        'entity:selected': 'entitySelected',
        'suggestor:selected:patient': 'onPatientSelected',
        'reviewers:added:to:document': 'onReviewersAdded'
    },

    ui: {
        fileSelector: '#file-input',
        uploadedDocumentsList: '#uploaded-documents-list',
        assign: '#assign',
        checkAll: '#check-all',
        addMeta: '#add-meta'
    },

    events: {
        'click input[type=checkbox]': 'onUploadedDocumentChecked',
        'click @ui.assign': 'onAssign',
        'click @ui.addMeta': 'onAddMeta',
        'click @ui.checkAll': 'onCheckAll'
    },

    defaultParameters: {
        'patientId': '',
        'documentTypeId': '',
        requestedFromFrontend: true
    },

    constants: {
        maxNumberOfItemsInControlWithSuggester: 20
    },

    initialize: function () {
        this.utils = new CommonUtils();
        var permissions = sessionChannel.request('get:permissions');
        if ((permissions.systemRoles || []).indexOf('ADMIN') <= -1) {
            this.canUploadForIds = (permissions.userPermissions || [])
                .filter(function (permission) {
                    return permission.canUploadFor
                })
                .map(function (permission) {
                    return {key: 'id', value: permission.permittedObjectId}
                });
        }

        this.docTypesCollection = new DocumentTypesCollection([], {
            params: [{key: 'sortby', value: 'name'}, {key: 'sortdir', value: 'ASC'}]
        });

        this.uploadedDocuments = [];
    },


    onRender: function () {
        window.document.title = "Upload documents";
        var that = this;
        that.parameters = _.clone(that.defaultParameters);

        that.organizationsSelectView = new EntitiesSelectView({
            entityType: 'organization',
            customPlaceholder: 'Select an organization',
            params: this.canUploadForIds
        });
        that.showChildView('organizations', that.organizationsSelectView);


        that.showChildView('patients', new RemoteSuggesterView({
            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
            + '&sortby=name&like_name=~~~&type=person&object_mergeable=false',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data.filter(function (item) {
                    return item.object && item.object.isPatient && item.object.mergeable === false;
                });
            },
            getValueFn: function (element) {
                return element.name;
            },
            findSelectedIdBySelectedIndex: function (arr, index) {
                return (arr[index] || {}).id;
            },
            placeholder: "Search and select a patient",
            classes: ["form-control"],
            tag: 'patient'
        }));

        that.docTypesCollection.fetch({
            success: function () {
                that.documentTypeSelectView = new EntitiesSelectView({
                    entityType: 'documentType',
                    customPlaceholder: 'Select a document type',
                    collectionValues: that.docTypesCollection
                });
                that.showChildView('docTypes', that.documentTypeSelectView);
            }
        });

        that.ui.fileSelector.fileinput({
            uploadUrl: "/api/document/upload/",
            allowedFileExtensions: that.fileExtension(),
            dropZoneTitle: 'Drag & drop files here &hellip; <br>Organization should be selected',
            uploadExtraData: that.parameters
        });

        that.ui.fileSelector.fileinput('disable');

        that.ui.fileSelector.on('fileuploaded', function (event, data, previewId, index) {
            var documentId = data.response.id;
            var documentName = data.response.name;

            that.uploadedDocuments.push({
                id: documentId,
                name: documentName,
                selected: false
            });
        });

        that.ui.fileSelector.on('filebatchuploadcomplete', function (event, files, extra) {
            that.renderUploadedDocumentsList();
        });
    },

    fileExtension: function() {
        return _.keys(Dicts.documentTypes)
    },

    entitySelected: function (data) {
        if (typeof data.id === 'undefined' || data.id == '') {
            if (data.type == 'documentType')
                this.parameters.documentTypeId = '';
            else if (data.type == 'organization')
                this.ui.fileSelector.fileinput('disable');
            return;
        }

        if (data.type == 'organization') {
            this.ui.fileSelector.fileinput('refresh', {uploadUrl: "/api/document/upload/" + data.id});
            this.ui.fileSelector.fileinput('enable');
        }

        if (data.type == 'documentType') {
            this.parameters.documentTypeId = data.id
        }
    },

    onPatientSelected: function (id) {
        this.parameters.patientId = (id == null ? '' : id);
    },

    renderUploadedDocumentsList: function () {
        var that = this;
        that.ui.uploadedDocumentsList.empty();
        that.uploadedDocuments.forEach(function (document) {
            var template = '<label class="checkbox"><input type="checkbox" id="' + document.id + '"/><a href="/#document/' + document.id
                + '" target="_blank">' + document.name + '</a></label>';
            that.ui.uploadedDocumentsList.append(template);
        });

        if (that.uploadedDocuments.length > 0) {
            that.ui.checkAll.parent().parent().show();
            that.ui.checkAll.prop('checked', true);
            that.uploadedDocuments.forEach(function (document) {
                document.selected = true;
            });
            that.checkOrUncheckAllCheckboxes(true);
        } else {
            that.ui.checkAll.parent().parent().hide();
            that.ui.checkAll.prop('checked', false);
        }
        that.checkSelectedDocuments();
    },

    onUploadedDocumentChecked: function (event) {
        var that = this;
        var selectedDocumentId = event.target.id;
        if (event.target.checked) {
            that.uploadedDocuments.forEach(function (document) {
                if (document.id == selectedDocumentId)
                    document.selected = true;
            });
        } else {
            that.uploadedDocuments.forEach(function (document) {
                if (document.id == selectedDocumentId)
                    document.selected = false;
            });
            that.ui.checkAll.prop('checked', false);
        }
        that.checkSelectedDocuments();
    },

    onCheckAll: function (event) {
        var that = this;
        if (event.target.checked) {
            that.uploadedDocuments.forEach(function (document) {
                document.selected = true;
            });
            that.checkOrUncheckAllCheckboxes(true);
        } else {
            that.uploadedDocuments.forEach(function (document) {
                document.selected = false;
            });
            that.checkOrUncheckAllCheckboxes(false);
        }
        that.checkSelectedDocuments();
    },

    checkOrUncheckAllCheckboxes: function (checked) {
        var that = this;
        that.ui.uploadedDocumentsList.find('input[type=checkbox]').each(function () {
            $(this).prop('checked', checked);
        });
    },

    checkSelectedDocuments: function () {
        var that = this;
        var selectedCnt = _.filter(that.uploadedDocuments, function (document) {
            return document.selected == true;
        }).length;

        if (selectedCnt == 0) {
            that.ui.assign.attr('disabled', true);
            that.ui.addMeta.attr('disabled', true);
        } else {
            that.ui.assign.removeAttr('disabled');
        }

        if (selectedCnt == 1)
            that.ui.addMeta.removeAttr('disabled');
    },

    onAssign: function () {
        var that = this;

        that.showChildView('assignReviewersFormRegion', new AssignReviewersForm({
            docIds: that.getSelectedDocumentsIds()
        }));
    },

    getSelectedDocumentsIds: function() {
        return this.uploadedDocuments.filter(function (document) {
            return document.selected == true;
        }).map(function (document) {
            return document.id;
        });
    },

    onReviewersAdded: function () {
        $.notify("Reviewers added successfully", "success");
    },

    onAddMeta: function() {
        var that = this;

        that.showChildView('addMetaFormRegion', new DocumentMetaModal({
            documentId: that.getSelectedDocumentsIds()[0],
            meta: that.utils.initialMeta()
        }));
    }
});

module.exports = DocumentUploadView;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/document-upload-view.js
// module id = 438
// module chunks = 0